import clsx from 'clsx';
import { memo, PropsWithChildren, useContext, useRef } from 'react';
import { ConfigContext } from 'src/configContext';
import { useSticky } from '../../hooks/useSticky';

type Props = PropsWithChildren<{
    isMobile: boolean;
}>;

export const NavigationContainer = memo(({ isMobile, children }: Props) => {
    const { rootElement } = useContext(ConfigContext);

    const containerRef = useRef<HTMLDivElement>(null);

    const stickyCheck = () => {
        if (containerRef.current === null) {
            return false;
        }

        const isContainerBottomOverflow = rootElement.getBoundingClientRect().bottom >
            containerRef.current.getBoundingClientRect().bottom;
        const isContainerTopOverflow = containerRef.current.getBoundingClientRect().bottom > window.innerHeight;

        return isContainerBottomOverflow || isContainerTopOverflow;
    };

    const isSticky = useSticky(stickyCheck);

    return (
        <>
            <div
                ref={containerRef}
                className={clsx({
                    'vss-navigation-container': true,
                    'vss-navigation-container--mobile': isMobile,
                    'vss-navigation-container--fixed': isMobile && isSticky,
                    'vss-navigation-container--absolute': isMobile && !isSticky,
                })}
            >
                {children}
            </div>

            {/* Duplicate the non-fixed container for the correct spacing */}
            {isMobile && (
                <div
                    className={
                        `vss-navigation-container
                        vss-navigation-container--mobile
                        vss-navigation-container--hidden`
                    }
                >
                    {children}
                </div>
            )}
        </>
    );
});
